import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AppInsightsService } from '../app-insights.service';
import { environment } from 'src/environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ISearchResults } from 'src/app/Shared/models/search.Model';
import {AppService} from '../app.service';


@Injectable({
    providedIn: 'root',
})

export class SearchService {
    private baseURL = this.appService.config.apiBaseUrl;
    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }

        getSearchResults(filterValue,facId): Observable<ISearchResults> {
            return this.http.get<ISearchResults>(
                `${this.baseURL}/Search/GetTenantDetails?filterValue=${filterValue}&facilityId=${facId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as ISearchResults;
                }),
                catchError(this.handleError)
            );

        }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}
